import { ColumnConfig, CustomerInvoiceColumnKey } from '../../model';

export const customerInvoiceConfig: Record<
  CustomerInvoiceColumnKey,
  ColumnConfig
> = {
  invoiceNumberDate: {
    name: 'Invoice No. & Date',
    isCheckboxField: true,
    isComponent: true,
  },
  // invoiceDate: {
  //   name: 'Invoice Date',
  //   sortField: 'invoiceDate',
  //   alignment: 'flex-end',
  // },
  // coNumber: {
  //   name: 'CO Number',
  // },
  // docType: {
  //   name: 'Doc Type',
  // },

  dueDate: {
    name: 'Due Date',
    sortField: 'dueDate',
    alignment: 'flex-end',
  },
  invoiceAmount: {
    name: 'Invoice Amount',
    sortField: 'invoiceAmount',
    alignment: 'flex-end',
  },
  // amountPaid: {
  //   name: 'Amount Paid',
  //   sortField: 'paidAmount',
  //   alignment: 'flex-end',
  // },
  // paymentId: {
  //   name: 'Payment ID',
  //   isComponent: true,
  // },
  // orderNumber: {
  //   name: 'Order Number',
  //   isComponent: true,
  //   isAdditional: true,
  //   isVisible: false,
  // },
  status: {
    name: 'Status',
    isComponent: true,
  },
  action: {
    name: '',
    alignment: 'flex-end',
  },
};
